<template>
  <el-container>
    <el-header height="200px" class="m-b-50">
      <el-row justify="space-between" :gutter="20">
        <el-col :span="8">
          <a href="//meine-landausfluege.de">
            <img
              alt="Brand"
              src="@/assets/logo.jpeg"
            >
          </a>
        </el-col>
        <el-col :span="16">
          <h2 class="text-right">{{ $t("widgetHeader") }}</h2>
        </el-col>
      </el-row>
      <el-row justify="space-between">
        <el-col :span="24">
          <el-menu class="el-menu-demo" mode="horizontal">
            <el-menu-item
              index="1"
            ><a class="nav-link" href="//meine-landausfluege.de/impressum/">{{
              $t("imprint")
            }}</a></el-menu-item>
            <el-menu-item
              index="2"
            ><a
              class="nav-link"
              href="//meine-landausfluege.de/datenschutz/"
            >{{ $t("dataProtection") }}</a></el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
      <el-row justify="space-between">
        <el-col :span="24">
          <el-alert type="warning" :closable="false">
            <p v-html="$t('simpleMethodDescription')" />
            <p v-html="$t('pleaseContactUsShort')" />
          </el-alert>
        </el-col>
      </el-row>
    </el-header>
  </el-container>
</template>

<script>
export default {
  name: 'Header',
};
</script>

<style scoped></style>
